import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";

export interface GetSportEventNewParams {
  id: number | string;
  lang: string;
  feedType: FeedType;
  providerId: number | string;
  // "sr": when the leg's provider has no live entry, sinek serves the live
  // minute/score from the Sportradar timeline instead of null. Sent as a
  // query param only when present.
  statusFallback?: "sr";
}

export const getSportEventNew = async (
  props: QueryProps<GetSportEventNewParams>
): Promise<SportEvent | undefined> => {
  const { id, ...queryParams } = props.params;
  const res = await api.client.get(`/sport-events-new/${id}`, {
    signal: props.signal,
    params: queryParams,
  });
  return res.data;
};
